import { render } from "./ReturnForm.vue?vue&type=template&id=9a82618a&scoped=true&ts=true"
import script from "./ReturnForm.vue?vue&type=script&lang=ts"
export * from "./ReturnForm.vue?vue&type=script&lang=ts"

import "./ReturnForm.vue?vue&type=style&index=0&id=9a82618a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a82618a"]])

export default __exports__